import {RaffleType} from "data/types";
import {FC} from "react";

export interface LuckyNumbersProps {
  luckyNumbers: RaffleType["luckyNumbers"];
  winnersNumbers: RaffleType["winnersNumbers"];
}

export const LuckyNumbers: FC<LuckyNumbersProps> = ({
  luckyNumbers,
  winnersNumbers,
}) => {
  return (
    <div className="mt-12">
      <h2 className="text-center text-md font-semibold mb-4 text-gray-700 dark:text-gray-200">
        Tickets dorados
      </h2>
      <span className="block text-center text-sm text-gray-500 dark:text-gray-400 mb-4">
        🍀 Los números premiados ya están aquí. Si coinciden con los tuyos,
        ¡recibes dinero en efectivo al momento! 💰
      </span>
      <div className="flex flex-wrap gap-4 justify-center">
        {[...luckyNumbers]
          .sort((a, b) => Number(a) - Number(b))
          .map((num, idx) => {
            const winner = winnersNumbers.find(
              (w) => w.winnerNumber === Number(num)
            );

            return (
              <div key={idx} className="flex flex-col items-center gap-1">
                <div
                  className={`relative w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center font-bold text-md sm:text-md rounded-full
            ${
              winner
                ? "bg-gray-200 dark:bg-neutral-600 text-black dark:text-white dark:shadow-xl dark:border-2 dark:border-neutral-800"
                : "bg-white dark:bg-neutral-800 text-black dark:text-white shadow-xl dark:border-2 dark:border-neutral-600 hover:scale-110 transition-transform"
            }`}
                >
                  <span
                    className={
                      winner
                        ? "line-through decoration-primary-500 decoration-[3px]"
                        : ""
                    }
                  >
                    {num}
                  </span>
                </div>

                {winner && (
                  <span className="text-xs text-center font-medium text-primary-600 dark:text-primary-500">
                    {winner.status === "CLAIMED" ? (
                      <>
                        Premio <br /> Entregado
                      </>
                    ) : (
                      ""
                    )}
                  </span>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};
